export const DAILY_GOAL = 'Daily goal';
export const DAILY_GOAL_BUTTON = 'More';
export const TOTAL_TIME = 'Total time';
